"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _excluded = ["size", "width", "height", "fill"];

var _default = function _default(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 24 : _ref$size,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? size : _ref$width,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? size : _ref$height,
      _ref$fill = _ref.fill,
      fill = _ref$fill === void 0 ? '#808080' : _ref$fill,
      restProps = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  return /*#__PURE__*/_react["default"].createElement("svg", (0, _extends2["default"])({
    width: size,
    height: size,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, restProps), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M43.75 23.4375H9.74996L21.3125 10.4167C21.5887 10.1073 21.7308 9.70076 21.7073 9.28661C21.6839 8.87247 21.4969 8.4846 21.1875 8.20834C20.878 7.93207 20.4715 7.79003 20.0574 7.81348C19.6433 7.83692 19.2554 8.02392 18.9791 8.33334L5.08329 23.9583C4.83127 24.2468 4.69238 24.6169 4.69238 25C4.69238 25.3831 4.83127 25.7532 5.08329 26.0417L18.9791 41.6667C19.1242 41.8329 19.3037 41.9656 19.5051 42.0555C19.7066 42.1455 19.9252 42.1905 20.1458 42.1875C20.5295 42.1861 20.8997 42.0455 21.1875 41.7917C21.4924 41.5127 21.6761 41.1256 21.6995 40.713C21.7229 40.3003 21.584 39.8949 21.3125 39.5833L9.74996 26.6667H43.75C44.1644 26.6667 44.5618 26.5021 44.8548 26.209C45.1478 25.916 45.3125 25.5186 45.3125 25.1042C45.3125 24.6898 45.1478 24.2923 44.8548 23.9993C44.5618 23.7063 44.1644 23.5417 43.75 23.5417V23.4375Z",
    fill: fill
  }));
};

exports["default"] = _default;